import { Provider } from "../../../classes/provider/Provider";

const plutioProvider = new Provider({
	id: "plutio",
	name: "Plutio",
	description: "Plutio is a cloud-based project management software that helps you manage your projects, clients, and team. It's easy to use and has a lot of features.",
	websiteHomeUrl: "https://plutio.com/",
	websiteSupportUrl: "https://help.plutio.com/en/",
	iconUrl: "https://storage.googleapis.com/cdn.version2.io/providers/plutio.png",
	color: "#3e11bf",
});

export default plutioProvider;